var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 22 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 .667h16a2.667 2.667 0 0 1 2.667 2.666v24H.333v-24A2.667 2.667 0 0 1 3 .667m0 24h5.333v-5.334h5.334v5.334H19V3.333H3zM12.333 6h4v4h-4zm-6.666 6.667h4v4h-4zm6.666 0h4v4h-4zM5.667 6h4v4h-4z"
  })));
};
export default SvgBuilding;